import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractDateFromXml'
})
export class ExtractDateFromXmlPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value.slice(value.indexOf("_")+1,value.indexOf("_")+11);
  }

}
